export const COOKIEBOT_ID = "9f1cf063-9e84-4061-9eaf-ac70441c6fa8";

export const COOKIE_DECLARATION_SCRIPT_URL = `https://consent.cookiebot.com/${COOKIEBOT_ID}/cd.js`;

export function openCookieSettings() {
  window.Cookiebot?.renew();
}
